import BaseApi from './base.api'
class PortalApi extends BaseApi {
  catalogsUrl = 'catalogs/'
  catalogRowsUrl = (catalogId) => `catalogs/${catalogId}/rows/`
  electronicInvoiceProgressStatusesUrl = 'electronic-invoice-progress-statuses/'
  electronicInvoiceFamiliesUrl = 'electronic-invoice-families/'
  electronicInvoiceSdiDocumentTypesUrl = 'electronic-invoice-sdi-document-types/'
  expenseTypesUrl = 'expense-types/'
  orderReasonsUrl = 'supplier-order-reasons/'
  printModelsUrl = 'print-models/'
  letterOfAppointmentUrl = 'tenants/letter-of-appointment/'
  localizationUrl = 'localizations/'
  productAnalyticGroupsUrl = 'product-analytic-groups/'
  productTypologiesUrl = 'product-typologies/'
  productManufacturerFamiliesUrl = 'product-manufacturer-families/'
  purchaseFamiliesUrl = 'purchase-families/'
  saleDepartmentsUrl = 'sale-departments/'
  settingsUrl = 'settings/'
  technicalQualificationsUrl = 'technical-qualifications/'
  vehicleTypesUrl = 'vehicle-types/'
  versionUrl = 'settings/version/'

  constructor() { super('portal/') }

  getCatalogsAsync = () => this.get(this.catalogsUrl)
  getDepartmentsAsync = () => this.get(this.departmentsUrl)
  getElectronicInvoiceProgressStatusesAsync = () => this.get(this.electronicInvoiceProgressStatusesUrl)
  getElectronicInvoiceFamiliesAsync = () => this.get(this.electronicInvoiceFamiliesUrl)
  getElectronicInvoiceSdiDocumentTypesAsync = (params) => this.get(this.electronicInvoiceSdiDocumentTypesUrl, params)
  getExpenseTypesAsync = () => this.get(this.expenseTypesUrl)
  getLanguagesAsync = () => this.get(`${this.localizationUrl}languages/`)
  getLocalizationsAsync = (languageCode) =>
    languageCode ? this.get(this.localizationUrl, { language: languageCode }) : this.get(this.localizationUrl)
  getProductAnalyticGroupsAsync = () => this.get(this.productAnalyticGroupsUrl)
  getProductTypologiesAsync = () => this.get(this.productTypologiesUrl)
  getProductManufacturerFamiliesAsync = () => this.get(this.productManufacturerFamiliesUrl)
  getPurchaseFamiliesAsync = (params) => this.get(this.purchaseFamiliesUrl, params)
  getPrintModelsAsync = (params) => this.get(this.printModelsUrl, params)
  getSaleDepartmentsAsync = (params) => this.get(this.saleDepartmentsUrl, params)
  getSettingsAsync = () => this.get(this.settingsUrl)
  getTechnicalQualificationsAsync = () => this.get(this.technicalQualificationsUrl)
  getVersionAsync = () => this.get(this.versionUrl)
  getVehicleTypesAsync = () => this.get(this.vehicleTypesUrl)
  getLetterOfAppointmentAsync = () => this.get(this.letterOfAppointmentUrl)
}
export const portalApi = new PortalApi()
